import A11y from '../components/A11y';
import { $ } from '../util/DOM';

const initA11y = () => {
  $('.a11y-controls__theme').forEach((btn) => {
    btn.addEventListener('click', () => {
      A11y.theme = A11y.theme === '' ? 'dark' : '';
    });
  });

  $('.a11y-controls__inc-font').forEach((btn) => {
    btn.addEventListener('click', () => {
      A11y.fontSize += 1;
    });
  });

  $('.a11y-controls__dec-font').forEach((btn) => {
    btn.addEventListener('click', () => {
      A11y.fontSize -= 1;
    });
  });
};

export default initA11y;
